import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { GridComponent } from "@syncfusion/ej2-angular-grids";
import {
  DataStateChangeEventArgs,
  FilterSettingsModel,
} from "@syncfusion/ej2-grids";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { v4 as uuidv4 } from "uuid";
import {
  DEEventEmitterBo,
  DynamicClientFormSaveBO,
  functionpermission,
  GenerateDynamicClientEmployeeFormBO,
  GetDynamicClientEmployeeFormBO,
  OfficeNotesBO,
  SendDynamicFormToClientBO,
  SendDynamicFormToEmployeeBO,
  SendDynamicToClientBO,
  SubmitEmployeeAggremntBo,
} from "../client-employee-dynamicform.model";
import { NgxExtendedPdfViewerService } from "ngx-extended-pdf-viewer";
import { NgxUiLoaderService } from "ngx-ui-loader";
// import { CommonApiService } from "src/app/commonapiservice";
import { ClientEmployeeDynamicFormListService } from "./client-employee-dynamicform-list.service";
import { ColumnChangeBO, columnWidth } from "../../employee/employee.model";
import { CommonHttpService } from "src/app/common.service";
import { ConfigurationService } from "src/app/configuration.service";
import { SubmitClientAggremntBo } from "../../client-onboarding/files/files.model";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-client-employee-dynamicform-list",
  templateUrl: "./client-employee-dynamicform-list.component.html",
  styleUrls: ["./client-employee-dynamicform-list.component.scss"],
})
export class ClientEmployeeDynamicformListComponent implements OnInit {
  @Input() ListCEInputProperty: DEEventEmitterBo = new DEEventEmitterBo();
  @Output() ListOutputCE = new EventEmitter<DEEventEmitterBo>();
  saveBo: DynamicClientFormSaveBO = new DynamicClientFormSaveBO();
  @ViewChild("gridDynamicForm") public gridDynamicForm: GridComponent;
  private onDestroy$: Subject<void> = new Subject<void>();
  ColumnArray: columnWidth[];
  pdfsrc: string;
  dynamicid: any;
  templateId: any;
  isAutosave: boolean = false;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  GetDynamicFormTemplateList: GetDynamicClientEmployeeFormBO =
    new GetDynamicClientEmployeeFormBO();
  generateDynamicFormBO: GenerateDynamicClientEmployeeFormBO =
    new GenerateDynamicClientEmployeeFormBO();
  id: number = 0;
  name: string;
  initialPage: object;
  formatOptions: object;
  Output: any = "";
  interval: any;
  filterOptions: FilterSettingsModel;
  type: string;
  arraycol: any = [];
  templateName: string = "";
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public GridDataList: Observable<DataStateChangeEventArgs>;
  MailMessage = "";
  fp:functionpermission = new functionpermission();
  public dropdatas = [
    { Status: 'Completed', Value: "true" },
    { Status: 'Not Completed', Value: "false" }
  ];
  public fields: Object = { text: "Status", value: "Value" };
  height: string = '220px'
  constructor(
    public loader: NgxUiLoaderService,
    private ngxService: NgxExtendedPdfViewerService,
    public global: GlobalComponent,
    public CEDynamicFormService: ClientEmployeeDynamicFormListService,
    public CommonAPI: CommonHttpService,
    public toasterService: ToastrService,
    public configurationservice: ConfigurationService,
  ) {
    this.GridDataList = this.CEDynamicFormService;
  }
  ngOnInit(): void {
    console.log('list')
    this.formatOptions = { type: "date", format: "MM/dd/yyyy HH:mm:ss" };
    let JsonPage = 10
    this.filterOptions = { type: "Menu" };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: JsonPage,
      pageSize: JsonPage,
      pageSizes: this.pageSizes,
    };
    this.getpermission();

    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      this.GetDynamicFormTemplateList.orderColumn = "clientName";
      this.GetDynamicFormTemplateList.field = "clientName";
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        this.GetDynamicFormTemplateList.orderColumn = "employeeName";
        this.GetDynamicFormTemplateList.field = "employeeName";
        this.getDynamicFormEmployeeFilter();
      } else {
        this.getDynamicFormClientFilter();
      }
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      this.GetDynamicFormTemplateList.orderColumn = "employeeName";
      this.GetDynamicFormTemplateList.field = "employeeName";
      this.getDynamicFormEmployeeFilter();
    }
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "DynamicTemplate");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.CommonAPI.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  //.................................................onActionComplete..............................................
  public onActionComplete(args) {
    this.GetDynamicFormTemplateList.currentpageno =
      this.gridDynamicForm.pagerModule.pagerObj.currentPage;
    this.GetDynamicFormTemplateList.pageitem =
      this.gridDynamicForm.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.GetDynamicFormTemplateList.type = args.columnType;
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridDynamicForm.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].activesession.ShowColumns.forEach((old) => {
          showarr.forEach((element) => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].activesession.HideColumns.forEach((old) => {
          hidearr.forEach((element) => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (
          this.arraycol[0].activesession.ShowColumns.length != count1 ||
          this.arraycol[0].activesession.HideColumns.length != count
        ) {
          this.arraycol[0].activesession.ShowColumns = showarr;
          this.arraycol[0].activesession.HideColumns = hidearr;
          this.SaveColumnwidth();
        }
      }
    }
  }
  //.................................................dataStateChange..............................................
  public dataStateChange(DFC): void {
    let val = DFC.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((DFC.sorted || []).length) {
        this.GetDynamicFormTemplateList.orderColumn = DFC.sorted[0].name;
        this.GetDynamicFormTemplateList.orderType =
          DFC.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && DFC.action.action != "clearFilter") {
      this.GetDynamicFormTemplateList.field =
        DFC.action.currentFilterObject.field;
      this.GetDynamicFormTemplateList.matchCase =
        DFC.action.currentFilterObject.matchCase;
      this.GetDynamicFormTemplateList.operator =
        DFC.action.currentFilterObject.operator;
      this.GetDynamicFormTemplateList.value =
        DFC.action.currentFilterObject.value;
    } else {
      if (val == "filtering" && DFC.action.action == "clearFilter") {
        if (this.ListCEInputProperty.details.Dynamictype == "Client") {
          this.GetDynamicFormTemplateList.type = "clientName";
          this.GetDynamicFormTemplateList.field = "clientName";
        } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
          this.GetDynamicFormTemplateList.type = "employeeName";
          this.GetDynamicFormTemplateList.field = "employeeName";
        }
        this.GetDynamicFormTemplateList.operator = "contains";
        this.GetDynamicFormTemplateList.value = "";
        this.GetDynamicFormTemplateList.matchCase = false;
      }
    }
    if (val == "paging" && DFC.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (
          this.arraycol[0].Dynamic_Client_Employee_Form.Pagesize != DFC.take
        ) {
          this.arraycol[0].Dynamic_Client_Employee_Form.Pagesize = DFC.take;
          //this.SaveColumnwidth();
        }
      }
    }
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        this.getDynamicFormEmployeeFilter();
      } else {
        if (this.global.OnboardingLoginType != 'onboardLogin') { }
        this.getDynamicFormClientFilter();
      }
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      this.getDynamicFormEmployeeFilter();
    }
  }
  //.................................................onResize..............................................
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.gridDynamicForm.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  //................................................SaveColumnwidth....................................
  SaveColumnwidth() {
    // this.arraycol[0].Dynamic_Client_Employee_Form.Columns = this.ColumnArray;
    // this.columnchange.agencyId = parseInt(this.global.globalAgencyId);
    // this.columnchange.userid = parseInt(this.global.userID);
    // this.columnchange.column = JSON.stringify(this.arraycol);
    // this.columnchange.id = this.id;
    // this.global.globalColumn = this.columnchange;
    // this.arraycol = JSON.parse(this.global.globalColumn.column);
    // let url = "api/ColumnChange/Savewidth?";
    // this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url)
    //   .pipe(takeUntil(this.onDestroy$))
    //   .subscribe((data: any) => {
    //     this.getColumnwidth();
    //   });
  }
  //................................................getColumnwidth....................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Dynamic_Client_Employee_Form.Columns;
    let showcol = this.arraycol[0].Dynamic_Client_Employee_Form.ShowColumns;
    let hidecol = this.arraycol[0].Dynamic_Client_Employee_Form.HideColumns;
    this.gridDynamicForm.showColumns(showcol);
    this.gridDynamicForm.hideColumns(hidecol);
    if (
      this.global.globalColumn.userid != null &&
      this.global.globalColumn.agencyId != null
    ) {
      this.id = this.global.globalColumn.id;
    }
    if (this.gridDynamicForm != undefined) {
      this.ColumnArray.forEach((element) => {
        if (element.column == "DynamicForm TemplateName") {
          const column = this.gridDynamicForm.getColumnByField(
            "dynamicFormTemplateName"
          );
          column.width = element.width;
          this.gridDynamicForm.refreshHeader();
        }
        if (element.column == "Created Date") {
          const column = this.gridDynamicForm.getColumnByField("createdOn");
          column.width = element.width;
          this.gridDynamicForm.refreshHeader();
        }
        if (element.column == "Group Name") {
          const column = this.gridDynamicForm.getColumnByField("dynamicFormGroupName");
          column.width = element.width;
          this.gridDynamicForm.refreshHeader();
        }
        if (this.ListCEInputProperty.details.Dynamictype == "Client") {
          if (element.column == "Client Name") {
            if (this.ListCEInputProperty.details.Dynamictype == "Client") {
              const column =
                this.gridDynamicForm.getColumnByField("clientName");
              column.width = element.width;
              this.gridDynamicForm.refreshHeader();
            }
          }
        }
        if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
          if (element.column == "Employee Name") {
            const column =
              this.gridDynamicForm.getColumnByField("employeeName");
            column.width = element.width;
            this.gridDynamicForm.refreshHeader();
          }
        }

        if (element.column == "Actions") {
          const column = this.gridDynamicForm.getColumnByUid("action");
          column.headerText = "Actions";
          column.width = element.width;
          this.gridDynamicForm.refreshHeader();
        }
      });
    }
  }
  //.................................................getDynamicFormClientFilter..............................................
  getDynamicFormClientFilter() {
    this.GetDynamicFormTemplateList.agencyID =
      (this.global.globalAgencyId != null &&
        this.global.globalAgencyId != undefined &&
        this.global.globalAgencyId != "" && this.global.globalAgencyId != "00000000-0000-0000-0000-000000000000")
        ? this.global.globalAgencyId
        : "00000000-0000-0000-0000-000000000000";
    this.GetDynamicFormTemplateList.clientId =
      this.ListCEInputProperty.details.Id;
    if (this.global.OnboardingLoginType == 'onboardLogin') {
      this.GetDynamicFormTemplateList.onboard = true;
    } else {
      this.GetDynamicFormTemplateList.onboard = false;
    }
    this.CEDynamicFormService.outputValuesClientForm(
      this.GetDynamicFormTemplateList
    );
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        if (data.result.length > 15) {
          this.gridDynamicForm.height = "500";
        } else {
          this.gridDynamicForm.height = "auto";
        }
        if (data != null && data != undefined) {
          //this.getColumnwidth();
        }
      }
    );
  }
  //.................................................getDynamicFormEmployeeList..............................................
  getDynamicFormEmployeeFilter() {
    this.GetDynamicFormTemplateList.agencyID =
      (this.global.globalAgencyId != null &&
        this.global.globalAgencyId != undefined &&
        this.global.globalAgencyId != "" && this.global.globalAgencyId != "00000000-0000-0000-0000-000000000000") ?
        this.global.globalAgencyId
        : "00000000-0000-0000-0000-000000000000";

    if (this.ListCEInputProperty.details.Dynamictype == "Client" && this.ListCEInputProperty.details.dynamicClientType == "Employee") {
      this.GetDynamicFormTemplateList.dynamicType = "Client";
      this.GetDynamicFormTemplateList.clientId =
        this.ListCEInputProperty.details.Id;
    } else {
      this.GetDynamicFormTemplateList.employeeId =
        this.ListCEInputProperty.details.Id;
    }
    let url = "";
    if (this.global.OnboardingLoginType == 'onboardLogin') {
      url = "api/DynamicEmployeeForm/getDynamicEmployeeFormListForPortal";
    } else {
      url = "api/DynamicEmployeeForm/getDynamicEmployeeFormList";
    }
    this.CEDynamicFormService.outputValuesEmployeeForm(url,
      this.GetDynamicFormTemplateList
    );
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        if (data.result.length > 15) {
          this.gridDynamicForm.height = "500";
        } else {
          this.gridDynamicForm.height = "auto";
        }
        if (data != null && data != undefined) {
          //   this.getColumnwidth();
        }
      }
    );
  }
  TempViewData: any
  //................................................checkDownloadType...........................................
  checkDownloadType(data) {
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        this.viewEmployeeDynamicforms(data.id);
      } else {
        this.viewClientDynamicforms(data.id);
      }
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      this.viewEmployeeDynamicforms(data.id);
    }
    this.TempViewData = data;
    console.log(this.TempViewData, "TempViewData");
    this.templateId = data.id;
  }
  //...........................................downloadUrl..............................................
  downloadUrl(Id) {
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        this.getDynamicEmployeeFormDownloadUrl(Id);
      } else {
        this.getDynamicClientFormDownloadUrl(Id);
        this.getDynamicFormClientFilter();
      }
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      this.getDynamicEmployeeFormDownloadUrl(Id);
    }
  } //................................................getDynamicClientFormDownloadUrl...........................................
  getDynamicClientFormDownloadUrl(id) {
    let params = new URLSearchParams();
    params.append("dynamicClientFormId", id);
    let url = "api/DynamicClientForm/DownloadDynamicClientForm?"
    this.CommonAPI.GetFunctionwithResponseTypeText(params, url).subscribe(
      (res) => {


        window.open(res);
      },
      (err: any) => {
        this.toasterService.error(err, "Error"), 8000;
      }
    );
  }
  //................................................getDynamicEmployeeFormDownloadUrl...........................................
  getDynamicEmployeeFormDownloadUrl(id) {
    let params = new URLSearchParams();
    params.append("dynamicEmployeeFormId", id);
    let url = "api/DynamicEmployeeForm/DownloadDynamicEmployeeForm?"

    this.CommonAPI.GetFunctionwithResponseTypeText(
      params, url
    ).subscribe(
      (res) => {
        window.open(res);
      },
      (err: any) => {
        this.toasterService.error(err, "Error"), 8000;
      }
    );
  }
  //................................................viewClientDynamicforms...........................................
  viewClientDynamicforms(id) {
    let params = new URLSearchParams();
    params.append("clientFormId", id.toString());
    let url = "api/DynamicClientForm/getClientDynamicFormView?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.Output = data;
        var blob = this.b64toBlob(this.Output.fileContents);
        this.pdfsrc = window.URL.createObjectURL(blob);
        document.getElementById("openViewModal").click();
      });
  }
  //................................................viewEmployeeDynamicforms...........................................
  viewEmployeeDynamicforms(id) {
    let params = new URLSearchParams();
    params.append("employeeFormId", id.toString());
    let url = "api/DynamicEmployeeForm/EmployeeDynamicFormView?"

    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.Output = data;
        var blob = this.b64toBlob(this.Output.fileContents);
        this.pdfsrc = window.URL.createObjectURL(blob);
        document.getElementById("openViewModal").click();
      });
  }
  //................................................downloadPdf...........................................
  downloadPdf() {

    var blob = this.b64toBlob(this.Output.fileContents);
    let a = document.createElement("a");
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      a.download = "Downloadclientform" + uuidv4().replace(/-/g, "") + ".pdf";
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      a.download = "DownloadEmployeeform" + uuidv4().replace(/-/g, "") + ".pdf";
    }

    a.click();
  }
  //................................................b64toBlob...........................................
  b64toBlob(b64Data) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: "application/pdf" });
    return blob;
  }
  //................................................setDynamicId...........................................
  setDynamicId(data) {
    this.dynamicid = data.id;
  }
  // ................................................checkDeleteType...............................................
  checkDeleteType() {
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      this.deleteDynamicClientForm();
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      this.deleteDynamicEmployeeForm();
    }
  }
  //................................................deleteDynamicClientForm...........................................
  deleteDynamicClientForm() {
    let params = new URLSearchParams();
    params.append("dynamicClientFormId", this.dynamicid.toString());
    let url = "api/DynamicClientForm/deleteDynamicClientForm?"
    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.getDynamicFormClientFilter();
          this.toasterService.success("Deleted Successfully");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);

          document.getElementById("deletedocument").click();
        },
        (err: any) => {
          this.toasterService.error(err, "error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }
  //................................................deleteDynamicEmployeeForm...........................................
  deleteDynamicEmployeeForm() {
    let params = new URLSearchParams();
    params.append("dynamicEmployeeFormId", this.dynamicid.toString());

    let url = "api/DynamicEmployeeForm/deleteDynamicEmployeeForm?"


    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.getDynamicFormEmployeeFilter();
          this.toasterService.success("Deleted Successfully");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);

          document.getElementById("deletedocument").click();
        },
        (err: any) => {
          this.toasterService.error(err, "error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }
  //................................................showDFT...........................................
  showDFT() {
    this.gridDynamicForm.columnChooserModule.openColumnChooser(500, -200);
  }
  //................................................OpenGenerateDynamicForm...........................................
  OpenGenerateDynamicForm(Fields) {
    this.ListCEInputProperty.isClose = null;
    this.ListCEInputProperty.isCreate = true;
    if (Fields == "generate") {
      this.ListOutputCE.emit(this.ListCEInputProperty);
    }
  }
  //................................................updatedynamicForm...........................................
  updatedynamicForm(autosave) {
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        this.updateDynamicEmployeeForm(autosave);
      } else {
        this.UpdateDynamicClientForm(autosave);
      }
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      this.updateDynamicEmployeeForm(autosave);
    }
  }
  //................................................UpdateDynamicClientForm...........................................
  async UpdateDynamicClientForm(autosave) {
    const blob = await this.ngxService.getCurrentDocumentAsBlob();
    let fileName: any;
    fileName = "Dynamicclientform" + uuidv4().replace(/-/g, "") + ".pdf";
    if (autosave == false) {
      this.loader.start();
    }
    const file = new File([blob], fileName);
    let Formdata = new FormData();
    Formdata.append("dynamicClientFormId", this.templateId);
    Formdata.append("file", file);
    let url = "api/DynamicClientForm/updateDynamicClientForm";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(Formdata, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          if (autosave == false) {
            this.loader.stop();
            this.toasterService.success("Form updated successfully");
          }
          if (autosave == true) {
            this.isAutosave = true;
            this.toasterService.success("Auto saved successfully");
          }
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  //................................................updateDynamicEmployeeForm...........................................
  async updateDynamicEmployeeForm(autosave) {
    const blob = await this.ngxService.getCurrentDocumentAsBlob();
    let fileName: any;
    fileName = "Dynamicemployeeform" + uuidv4().replace(/-/g, "") + ".pdf";
    if (autosave == false) {
      this.loader.start();
    }
    const file = new File([blob], fileName);
    let Formdata = new FormData();
    Formdata.append("dynamicEmployeeFormId", this.templateId);
    Formdata.append("file", file);
    let url = "api/DynamicEmployeeForm/updateDynamicEmployeeForm?"

    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(Formdata, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          if (autosave == false) {
            this.loader.stop();
            this.toasterService.success("Form updated successfully");
          }
          if (autosave == true) {
            this.isAutosave = true;
            this.toasterService.success("Auto saved successfully");
          }
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  //................................................dynamicFormScheduleRefresh...........................................
  dynamicFormScheduleRefresh() {
    this.interval = setInterval(() => {
      this.updatedynamicForm(true);
    }, 60000);
  }
  //................................................dynamicFormScheduleRefresh...........................................
  destroyInterval() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.isAutosave = false;
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        this.getDynamicFormEmployeeFilter();
      } else {
        this.getDynamicFormClientFilter();
      }
    } else if (this.ListCEInputProperty.details.Dynamictype == "Employee") {
      this.getDynamicFormEmployeeFilter();
    }
  }

  sendToClient() {
    console.log(this.TempViewData, 'dddddddd')

    let data = new SendDynamicToClientBO();
    data.clientId = this.ListCEInputProperty.details.Id.toString()
    data.documentLid = this.TempViewData.id;
    data.agencyNote = this.MailMessage;
    data.portalLink = this.configurationservice.environment.onboardingUrl + '#/onboarding/client/'


    let url = "api/DynamicClientForm/sendDynamicFormToClient";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Sent To Client successfully");
          document.getElementById("openMailModal").click();
          // document.getElementById("openPdfModal").click();
          // this.closeEdit();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }

  sendToEmployee() {
    console.log(this.TempViewData, 'dddddddd')

    let data = new SendDynamicFormToEmployeeBO();
    data.id = this.TempViewData.employeeId;
    data.employeeDocumentId = this.TempViewData.id;
    data.agencyNote = this.MailMessage;
    data.portalLink = this.configurationservice.environment.onboardingUrl + '#/onboarding/employee/'


    let url = "api/DynamicEmployeeForm/sendDynamicFormToEmployee";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Sent To Employee successfully");
          document.getElementById("openMailModal").click();
          // document.getElementById("openPdfModal").click();
          // this.closeEdit();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }

  sendToEmployeeinClient() {
    console.log(this.TempViewData, 'dddddddd')

    let data = new SendDynamicFormToClientBO();

    data.id = this.TempViewData.clientId;
    data.employeeDocumentId = this.TempViewData.id;
    data.agencyNote = this.MailMessage;
    data.portalLink = this.configurationservice.environment.onboardingUrl + '#/onboarding/client/'


    let url = "api/DynamicEmployeeForm/sendDynamicFormToClient";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Sent To Client successfully");
          document.getElementById("openMailModal").click();
          // document.getElementById("openPdfModal").click();
          // this.closeEdit();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }


  Submit() {
    if (this.ListCEInputProperty.details.Dynamictype == 'Client') {
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        this.submitForEmployee();
      }
      else {
        this.SubmitForClient();
      }
    } else if (this.ListCEInputProperty.details.Dynamictype == 'Employee') {
      this.submitForEmployee();
    }
  }

  SubmitForClient() {
    console.log(this.TempViewData, 'dddddddd')

    let data = new SubmitClientAggremntBo();

    data.aggrementId = this.TempViewData.id;
    data.type = "Client";
    let url = "api/DynamicClientForm/submitClientDynamicForm";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Submitted successfully");
          // document.getElementById("openTemplateModal").click();
          // document.getElementById("openPdfModal").click();
          // this.closeEdit();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }

  submitForEmployee() {

    console.log(this.TempViewData, 'dddddddd')

    let data = new SubmitEmployeeAggremntBo();
    data.type = this.ListCEInputProperty.details.Dynamictype == "Client" && this.ListCEInputProperty.details.dynamicClientType == "Employee" ? "Client" : "Employee";
    data.aggrementId = this.TempViewData.id;

    let url = "api/DynamicEmployeeForm/submitDynamicEmployeeForm";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Submitted successfully");
          // document.getElementById("openTemplateModal").click();
          // document.getElementById("openPdfModal").click();
          // this.closeEdit();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );


  }

  complete() {
    if (this.ListCEInputProperty.details.Dynamictype == 'Client') {
      this.completeClientForm();
    }
    else {
      this.completeEmployeeForm();
    }
  }

  completeClientForm() {
    console.log(this.TempViewData, 'dddddddd')

    let data = new SubmitClientAggremntBo();

    data.aggrementId = this.TempViewData.id;

    let url = "api/DynamicClientForm/CompleteDynamicClientForm";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Completed successfully");
          // document.getElementById("openTemplateModal").click();
          // document.getElementById("openPdfModal").click();
          // this.closeEdit();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );


  }

  completeEmployeeForm() {
    console.log(this.TempViewData, 'dddddddd')

    let data = new SubmitClientAggremntBo();

    data.aggrementId = this.TempViewData.id;

    let url = "api/DynamicEmployeeForm/CompleteDynamicEmployeeForm";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("Completed successfully");
          // document.getElementById("openTemplateModal").click();
          // document.getElementById("openPdfModal").click();
          // this.closeEdit();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }

  viewClientCompltedDynamicforms(id) {
    let params = new URLSearchParams();
    let url;
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      if (this.ListCEInputProperty.details.dynamicClientType == "Employee") {
        url = "api/DynamicEmployeeForm/EmployeeDynamicFormView?"
        params.append("employeeFormId", id.toString());
      } else {
        url = "api/DynamicClientForm/getClientDynamicFormView?"
        params.append("clientFormId", id.toString());
      }
    } else {
      url = "api/DynamicEmployeeForm/EmployeeDynamicFormView?"
      params.append("employeeFormId", id.toString());
    }

    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.Output = data;
        var blob = this.b64toBlob(this.Output.fileContents);
        this.pdfsrc = window.URL.createObjectURL(blob);
        document.getElementById("opencompltedDocModal").click();

      });
  }

  Type;
  clearMailMessage(type: string) {
    this.MailMessage = '';
    if (type == "Employee") {
      this.Type = "Employee";
    }
    if (type == "Employer") {
      this.Type = "Employer";
    }
  }

  SendToPortalwithMail() {
    if (this.ListCEInputProperty.details.Dynamictype == 'Client' && this.global.LoginUserType != 'Onboard' && this.TempViewData?.status == 'Pending') {
      this.sendToClient();
    } else if (this.Type == "Employer" && this.ListCEInputProperty.details.Dynamictype == 'Employee' && this.global.LoginUserType != 'Onboard' && this.TempViewData?.employerStatus == 'Pending') {
      this.sendToEmployeeinClient();
    } else if (this.Type == "Employee" && this.ListCEInputProperty.details.Dynamictype == 'Employee' && this.global.LoginUserType != 'Onboard' && this.TempViewData?.status == 'Pending') {
      this.sendToEmployee();
    }

  }


  getOfficeNotes(data) {
    this.officeNotes = data.officeNotes;
    this.TempViewData = data;
  }

  officeNotes;
  saveOfficeNotes() {
    let savenotesbo = new OfficeNotesBO();
    let url = "";
    savenotesbo.officenotes = this.officeNotes;
    savenotesbo.documentLid = this.TempViewData.id;
    if (this.ListCEInputProperty.details.Dynamictype == "Client") {
      url = "api/DynamicClientForm/SaveDynamicClientOfficeNotes";
    } else {
      url = "api/DynamicEmployeeForm/SaveDynamicEmployeeOfficeNotes";
    }

    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(savenotesbo, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.toasterService.success("Office Notes saved successfully");
        if (this.ListCEInputProperty.details.Dynamictype == "Client") {
          this.getDynamicFormClientFilter();
        } else {
          this.getDynamicFormEmployeeFilter();
        }
        document.getElementById("openOfficeNotes").click();
      });
  }

  clearOfficeNotes() {
    this.officeNotes = "";
  }
  //................................................ngOnDestroy...........................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
